import { displayTextLabelValidator } from '@vista-digital/occ-domain';
import { Validator } from '@vista-digital/validator';
export const defaultOccOrderDisplayText = {
    itemImageListRemainingCountFormat: '+${remainingCount}',
    itemLimitReachedMessage: 'You have added the maximum number of items that can be added to this order. Please remove existing items from your order to add new items.',
    itemModifierDetailsPaidFormat: '${quantity}x ${description} (${totalPrice})',
    itemModifierDetailsUnpaidFormat: '${quantity}x ${description}',
    ticketDetailsFormat: '${quantity}x ${description}',
    inProgressItemLimitReachedMessage: 'You have reached the maximum number of items allowed in an order.',
    inProgressItemRedemptionLimitReachedMessage: 'You have reached the maximum number of items available for this price.',
    taxLabel: 'Tax',
    estimatedTaxLabel: 'Estimated tax',
    bookingFeeLabel: 'Booking fee',
    includedBookingFeeLabel: 'Includes booking fee',
    nonRefundableBookingFeeLabel: 'Booking fee (non-refundable)',
    subtotalCostExcludingBookingFeeLabel: 'Subtotal',
    subtotalCostIncludingBookingFeeLabel: 'Subtotal (Incl. booking fee of ${bookingFee})',
    tipPercentageLabel: 'Tip (${tipPercentage})',
    tipPercentageFormat: '${tipPercentage}%',
    tipLabel: 'Tip',
    zeroTipLabel: 'No tip',
    changeTipButtonLabel: 'Change',
    totalCostLabel: 'Total',
    totalRefundedLabel: 'Total refunded',
    totalRefundableLabel: 'Total refundable',
    totalSavingsLabel: 'Your savings',
    patronCommentFormat: '"${comment}"'
};
export const occOrderDisplayTextValidator = Validator.object({
    itemImageListRemainingCountFormat: Validator.nonEmptyString,
    itemLimitReachedMessage: Validator.nonEmptyString,
    itemModifierDetailsPaidFormat: Validator.nonEmptyString,
    itemModifierDetailsUnpaidFormat: Validator.nonEmptyString,
    ticketDetailsFormat: Validator.nonEmptyString,
    inProgressItemLimitReachedMessage: Validator.nonEmptyString,
    inProgressItemRedemptionLimitReachedMessage: Validator.nonEmptyString,
    taxLabel: Validator.nonEmptyString,
    estimatedTaxLabel: Validator.nonEmptyString,
    bookingFeeLabel: displayTextLabelValidator,
    includedBookingFeeLabel: displayTextLabelValidator,
    nonRefundableBookingFeeLabel: displayTextLabelValidator,
    subtotalCostExcludingBookingFeeLabel: Validator.nonEmptyString,
    subtotalCostIncludingBookingFeeLabel: displayTextLabelValidator,
    tipPercentageLabel: displayTextLabelValidator,
    tipPercentageFormat: displayTextLabelValidator,
    tipLabel: displayTextLabelValidator,
    zeroTipLabel: displayTextLabelValidator,
    changeTipButtonLabel: Validator.nonEmptyString,
    totalCostLabel: Validator.nonEmptyString,
    totalRefundedLabel: Validator.nonEmptyString,
    totalRefundableLabel: Validator.nonEmptyString,
    totalSavingsLabel: Validator.nonEmptyString,
    patronCommentFormat: Validator.nonEmptyString
});
//# sourceMappingURL=order.js.map